import { ModalWindowBodyProps } from './components/modal-window-body'
import { ModalWindowContainerProps } from './components/modal-window-container'
import { ModalWindowFooterProps } from './components/modal-window-footer'
import { ModalWindowHeaderProps } from './components/modal-window-header'

export enum ModalWindowSizeEnum {
  Small = 'sm',
  Medium = 'md',
}

export interface CommonModalWindowProps
  extends Omit<ModalWindowContainerProps, 'children'>,
    Omit<ModalWindowHeaderProps, 'children'>,
    ModalWindowFooterProps,
    ModalWindowBodyProps {
  title?: string
}
